<template>
  <div id="placeholder">
    <h1>UAT Links:</h1>
    <a
      v-bind:href="'http://uat.form.betmakers.com/182128/1'"
      target="popup"
      onclick="window.open('http://uat.form.betmakers.com/182128/1','popup', 'width=auto,height=auto'); return false;"
    >Example - BetMakers - UAT</a>
    <h1>Production Links:</h1>
    <a
      v-bind:href="'https://betmakers.bet-form.com/182128/1'"
      target="popup"
      onclick="window.open('https://betmakers.bet-form.com/182128/1','popup', 'width=auto,height=auto'); return false;"
    >Example - BetMakers</a>
    <br />
    <a
      v-bind:href="'https://neds.bet-form.com/182128/1'"
      target="popup"
      onclick="window.open('https://neds.bet-form.com/182128/1','popup','width=auto,height=auto'); return false;"
    >Example - Neds</a>
    <br />
    <a
      v-bind:href="'https://do.bet-form.com/182128/1'"
      target="popup"
      onclick="window.open('https://do.bet-form.com/182128/1','popup','width=auto,height=auto'); return false;"
    >Example - Dynamic Odds</a>
    <br />
    <a
      v-bind:href="'https://topsport.bet-form.com/182128/1'"
      target="popup"
      onclick="window.open('https://topsport.bet-form.com/182128/1','popup','width=auto,height=auto'); return false;"
    >Example - TopSport</a>
    <br />
    <a
      v-bind:href="'https://robwaterhouse.bet-form.com/182128/1'"
      target="popup"
      onclick="window.open('https://robwaterhouse.bet-form.com/182128/1','popup','width=auto,height=auto'); return false;"
    >Example - Rob Waterhouse</a>
    <br />
    <a
      v-bind:href="'https://realbookie.bet-form.com/182128/1'"
      target="popup"
      onclick="window.open('https://realbookie.bet-form.com/182128/1','popup','width=auto,height=auto'); return false;"
    >Example - RealBookie</a>
    <br />
    <a
      v-bind:href="'https://picnicbet.bet-form.com/182128/1'"
      target="popup"
      onclick="window.open('https://picnicbet.bet-form.com/182128/1','popup','width=auto,height=auto'); return false;"
    >Example - PicnicBet</a>
    <br />
    <a
      v-bind:href="'https://crossbet.bet-form.com/182128/1'"
      target="popup"
      onclick="window.open('https://crossbet.bet-form.com/182128/1','popup','width=auto,height=auto'); return false;"
    >Example - CrossBet</a>
    <br />
    <a
      v-bind:href="'https://zbet.bet-form.com/182128/1'"
      target="popup"
      onclick="window.open('https://zbet.bet-form.com/182128/1','popup','width=auto,height=auto'); return false;"
    >Example - ZBet</a>
    <br />
    <a
      v-bind:href="'https://bbet.bet-form.com/182128/1'"
      target="popup"
      onclick="window.open('https://bbet.bet-form.com/182128/1','popup','width=auto,height=auto'); return false;"
    >Example - BBet</a>
    <br />
    <a
      v-bind:href="'https://nztab.bet-form.com/182128/1'"
      target="popup"
      onclick="window.open('https://nztab.bet-form.com/182128/1','popup','width=auto,height=auto'); return false;"
    >Example - NZ TAB</a>
    <br />
    <a
      v-bind:href="'https://mailbag.bet-form.com/182128/1'"
      target="popup"
      onclick="window.open('https://mailbag.bet-form.com/182128/1','popup','width=auto,height=auto'); return false;"
    >Example - The Mailbag</a>
    <br />
    <a
      v-bind:href="'https://betdeluxe.bet-form.com/182128/1'"
      target="popup"
      onclick="window.open('https://betdeluxe.bet-form.com/182128/1','popup','width=auto,height=auto'); return false;"
    >Example - BetDeluxe</a>
    <br />
    <a
      v-bind:href="'https://dimers.bet-form.com/182128/1'"
      target="popup"
      onclick="window.open('https://dimers.bet-form.com/182128/1','popup','width=auto,height=auto'); return false;"
    >Example - Dimers</a>
    <br />
    <a
      v-bind:href="'https://texbet.bet-form.com/182128/1'"
      target="popup"
      onclick="window.open('https://texbet.bet-form.com/182128/1','popup','width=auto,height=auto'); return false;"
    >Example - TexBet</a>
    <h2>Development Link (do not open):</h2>
    <a href="http://topsport.bet-form.localhost:8080/182128/1">Dev Link</a>
  </div>
</template>

<script>
export default {
  name: 'Placeholder'
}
</script>

<style scoped>
</style>
